(function () {
// Warning!!! This an auto generated file. Any Changes will be lost. If u want to add or edit go to config.json 

a3_cabin_reports.constant("version", "appVersion_20170424105730");

})();